import Microgame from '../engine/Microgame.js';

export default class SpinGame extends Microgame {

    static getPlayback() {
        return {
            title: { fr: `Tourne !`, en: `Spin!`, es: `¡Gira!` },
            controls: { fr: `Fais des cercles avec ton doigt ou ta souris`, en: `Make circles with your finger or mouse`, es: `Haz círculos con tu dedo o ratón` },
            objective: { fr: `Fais tourner l'objet assez vite pour gagner`, en: `Spin the object fast enough to win`, es: `Haz girar el objeto lo suficientemente rápido para ganar` },
            icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="var(--accent-color)" stroke-width="2"><path d="M21 12a9 9 0 1 1-9-9c2.52 0 4.93 1 6.74 2.74L21 8"/><path d="M21 3v5h-5"/></svg>`,
            actions: [
                { type: 'wait', duration: 240 },
                { type: 'swipe', fromX: 50, fromY: 50, toX: 57, toY: 28, duration: 420 },
                { type: 'wait', duration: 600 },
            ],
            loopDuration: 2400
        };
    }
    constructor(engine) {
        super(engine);
        this.angle = 0;
        this.targetAngle = 0;
        this.isDragging = false;
        this.wheel = null;
    }

    setup() {
        this.engine.ui.instruction.textContent = "SPIN!";

        const wheelContainer = document.createElement('div');
        wheelContainer.style.position = 'absolute';
        wheelContainer.style.top = '50%';
        wheelContainer.style.left = '50%';
        wheelContainer.style.transform = 'translate(-50%, -50%)';
        wheelContainer.style.width = '250px';
        wheelContainer.style.height = '250px';
        this.container.appendChild(wheelContainer);
        this.wheelContainer = wheelContainer; // Save reference

        // The Wheel (Spinner) - Create once
        this.wheel = document.createElement('div');
        this.wheel.style.position = 'absolute';
        this.wheel.style.width = '100%';
        this.wheel.style.height = '100%';
        this.wheel.style.borderRadius = '50%';
        this.wheel.style.border = `5px solid ${this.primaryColor}`;
        this.wheel.style.boxShadow = `0 0 15px ${this.primaryColor}`;
        this.wheelContainer.appendChild(this.wheel);

        // Handle (Pointer)
        const handle = document.createElement('div');
        handle.style.position = 'absolute';
        handle.style.top = '10px';
        handle.style.left = '50%';
        handle.style.transform = 'translateX(-50%)';
        handle.style.width = '20px';
        handle.style.height = '20px';
        handle.style.background = '#fff';
        handle.style.borderRadius = '50%';
        this.wheel.appendChild(handle);

        // Events
        this.onMove = this.onMove.bind(this);
        this.onDown = this.onDown.bind(this);
        this.onUp = this.onUp.bind(this);

        this.engine.input.element.addEventListener('pointerdown', this.onDown);
        this.engine.input.element.addEventListener('pointermove', this.onMove);
        this.engine.input.element.addEventListener('pointerup', this.onUp);

        this.startRound();
    }

    startRound() {
        // Reset Angle (Visual)
        // Keep current angle? Or reset? Let's keep current to be smooth.
        // But we need a new target.

        // Remove old target indicator
        if (this.targetIndicator) this.targetIndicator.remove();

        this.targetAngle = this.isPlayback ? 0 : (Math.random() * 360);

        // Target Indicator (Background)
        const target = document.createElement('div');
        target.style.position = 'absolute';
        target.style.width = '100%';
        target.style.height = '100%';
        target.style.borderRadius = '50%';
        target.style.border = '10px solid #333';
        // Conic gradient to show target zone
        target.style.background = `conic-gradient(transparent ${this.targetAngle}deg, ${this.secondaryColor} ${this.targetAngle}deg, ${this.secondaryColor} ${this.targetAngle + 40}deg, transparent ${this.targetAngle + 40}deg)`;
        target.style.opacity = '0.5';

        // Insert before wheel
        this.wheelContainer.insertBefore(target, this.wheel);
        this.targetIndicator = target;
    }

    onDown(e) {
        this.isDragging = true;
    }

    onUp(e) {
        this.isDragging = false;
        this.checkWin();
    }

    onMove(e) {
        if (!this.isDragging || !this.active) return;

        const rect = this.wheel.getBoundingClientRect();
        const centerX = rect.left + rect.width / 2;
        const centerY = rect.top + rect.height / 2;

        const x = e.clientX - centerX;
        const y = e.clientY - centerY;

        // Calculate angle
        let deg = Math.atan2(y, x) * (180 / Math.PI);
        deg += 90; // Adjust so top is 0
        if (deg < 0) deg += 360;

        this.angle = deg;
        this.wheel.style.transform = `rotate(${this.angle}deg)`;
    }

    checkWin() {
        // Normalize angles
        let diff = Math.abs(this.angle - (this.targetAngle + 20)); // +20 to center of 40deg zone
        if (diff > 180) diff = 360 - diff;

        if (diff < 20) {
            // Infinite logic
            if (this.engine.activeChallenge && (this.engine.activeChallenge.mode === 'infinite' || (this.engine.activeChallenge.config && this.engine.activeChallenge.config.timeAttack))) {
                this.engine.score++;
                this.engine.updateHUD();
                this.startRound();
            } else {
                this.win();
            }
        }
    }

    cleanup() {
        super.cleanup();
        this.engine.input.element.removeEventListener('pointerdown', this.onDown);
        this.engine.input.element.removeEventListener('pointermove', this.onMove);
        this.engine.input.element.removeEventListener('pointerup', this.onUp);
    }
}
